import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取订单物流列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listStoreOrderLogistics(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.listStoreOrderLogistics',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询物流详情
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function queryLogisticsDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryLogisticsDetail',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}